import { useFilterContext } from '../../contexts/FiltersContext';
import { MakeFilter } from '../../models/Filter';
import BaseFilterChip from './BaseFilterChip';

type MakeFilterChipProps = {
  filter: MakeFilter;
};

const OrganizationsFilterChip = ({ filter }: MakeFilterChipProps) => {
  // Dependencies
  const { handleRemoveFilter, organizationsFilterData } = useFilterContext();

  // Helpers
  const getOrgNameFromId = (orgId: string) => {
    return organizationsFilterData?.find((o) => o.key === orgId)?.value;
  };

  // Derived states
  const textValue = filter?.values?.map((value) => getOrgNameFromId(value))?.join(', ');

  return (
    <BaseFilterChip
      key={filter.attributeKey}
      filter={filter}
      onRemove={() => {
        handleRemoveFilter(filter);
      }}
      text={textValue}
    />
  );
};

export default OrganizationsFilterChip;
